import React from "react";
import { GridColumn, GridRow, Button } from "arv-reactcomponents";
import Anchor from "../../../../component/Anchor";
import { CONTACT_US_V2 } from "npmlinks-constants";

const ContactUsMessage = () => {
  const teleAttribute = "tel:";
  const mailAttribute = "mailto:";
  return (
    <GridRow className="nw-contactusv2message-container">
      <GridColumn className="nwc-grid-col-sm nw-contactusv2message-detail nw-contactusv2message-faqblock">
        <Anchor.component
          href={CONTACT_US_V2.FAQ}
          to={CONTACT_US_V2.FAQ}
          className="nw-contactusv2message-anchor"
        >
          <div className="nw-contactusv2message-iconblock">
            <div className="nw-contactusv2message-iconcontainer">
              <i className="icomoon-faqs nw-contactusv2message-icon" />
            </div>
          </div>
          <div className="nw-contactusv2message-infocontainer">
            <h4 className="nw-contactusv2message-message">
              {" "}
              {CONTACT_US_V2.message1.message}{" "}
            </h4>
            <div className="nw-contactusv2message-info">
              {CONTACT_US_V2.message1.info}
            </div>
          </div>
        </Anchor.component>
      </GridColumn>
      <GridColumn className="nwc-grid-col-sm nw-contactusv2message-detail nw-contactusv2message-emailblock">
        <a
          href={`${mailAttribute} ${CONTACT_US_V2.message3.info}`}
          className="nw-contactusv2message-anchor"
        >
          <div className="nw-contactusv2message-iconblock">
            <div className="nw-contactusv2message-iconcontainer">
              <i className="icomoon-email-us nw-contactusv2message-icon" />
            </div>
          </div>
          <div className="nw-contactusv2message-infocontainer">
            <h4 className="nw-contactusv2message-message">
              {" "}
              {CONTACT_US_V2.message3.message}{" "}
            </h4>
            <div className="nw-contactusv2message-info">
              {CONTACT_US_V2.message3.info}
            </div>
            <div className="nw-contactusv2message-info">
              {CONTACT_US_V2.message3.detail}
            </div>
          </div>
        </a>
      </GridColumn>
      {CONTACT_US_V2.message2.visibility ? (
        <GridColumn className="nwc-grid-col-sm nw-contactusv2message-detail nw-contactusv2message-callusblock">
          <a
            href={`${teleAttribute} ${CONTACT_US_V2.message2.info}`}
            className="nw-contactusv2message-anchor"
          >
            <div className="nw-contactusv2message-iconblock">
              <div className="nw-contactusv2message-iconcontainer">
                <i className="icomoon-call-us nw-contactusv2message-phoneicon" />
              </div>
            </div>
            <div className="nw-contactusv2message-infocontainer">
              <h4 className="nw-contactusv2message-message">
                {" "}
                {CONTACT_US_V2.message2.message}{" "}
              </h4>
              <div className="nw-contactusv2message-info">
                {CONTACT_US_V2.message2.info}
              </div>
              <div className="nw-contactusv2message-info">
                {" "}
                {CONTACT_US_V2.message2.detail}{" "}
              </div>
            </div>
          </a>
        </GridColumn>
      ) : null}
    </GridRow>
  );
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ContactUsMessage,
  component: ContactUsMessage,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/ContactUs/V2/ContactUsMessage/index.js